import { CommonModule } from '@angular/common';
import {Component, Input} from '@angular/core';
import { AdditionalPACData } from '../../models/additional-pac-data.model';
import {AppConstants} from '../../shared/app-constants';


@Component({
  selector: 'app-confirm-deposit-details',
  imports: [CommonModule],
  templateUrl: './confirm-deposit-details.component.html',
  styleUrl: './confirm-deposit-details.component.scss'
})
export class ConfirmDepositDetailsComponent {

  @Input() pacDetails!: AdditionalPACData;
  pacReference: string | undefined = '';

  showAmountFormatted(value: number | null | undefined): string {
    return AppConstants.showAmountFormatted(value);
  }

}
